<template>
  <div class="component-content">
    <div class="component-header">
      <a-row style="width: 100%">
        <a-col :span="4">
          <div style="width: 44px; height: 44px">
            <img
              :src="componentTreeWhiteImg"
              style="width: 100%; height: 100%; margin-top: 5px;cursor: pointer;"
              alt=""
            />
          </div>
        </a-col>
        <a-col :span="10" style="height: 90%"
          ><div class="component-header-text">组件树</div></a-col
        >
      </a-row>
    </div>
    <div class="divideLine" />
    <div class="tree">
      <a-tree
        :tree-data="treeData"
        show-icon
        default-expand-all
        :default-selected-keys="['0-0-0']"
        @select="onSelect"
      >
        <img
          :src="componentImg"
          slot="component"
          style="width: 16px; height: 16px"
        />
        <img
          :src="componentImg"
          slot="componentNoChoose"
          style="width: 16px; height: 16px; opacity: 0.6"
        />
      </a-tree>
    </div>
  </div>
</template>
<script>
const treeData = [
  {
    title: "页面",
    key: "0-0",
    slots: {
      icon: "component",
    },
    children: [
      {
        title: "编组",
        key: "0-0-0",
        slots: { icon: "component" },
        children: [
          { title: "组件名称", key: "0-0-0-0", slots: { icon: "component" } },
          { title: "组件名称", key: "0-0-0-1", slots: { icon: "component" } },
          {
            title: "组件名称",
            key: "0-0-0-2",
            slots: { icon: "component" },
          },
        ],
      },
      { title: "编组", key: "0-0-1", slots: { icon: "component" } },
      { title: "编组", key: "0-0-2", slots: { icon: "component" } },
    ],
  },
];
export default {
  data() {
    return {
      treeData,
      componentImg: require("@/assets/edit-page/componentFull.png"),
      componentTreeWhiteImg: require("@/assets/edit-page/componentTreeWhite.png"),
    };
  },

  mounted() {},
  created() {},
  methods: {
    onSelect(selectedKeys, info) {
      console.log("selected", selectedKeys, info);
    },
  },
};
</script>
<style lang="less" scoped>
@import "./showComponentTree.css";
</style>